import type { FormSchemaDto } from 'shared';

import { api } from './client.js';

export async function getActiveSchema(): Promise<FormSchemaDto> {
  const res = await api.get<{ schema: FormSchemaDto }>('/schema/active');
  return res.data.schema;
}
